import CheckDarkIcon from "@/User/Assets/Svgs/CheckDarkIcon.svg";
import ChevronDownIcon from "@/User/Assets/Svgs/ChevronDownFillBlackIcon.svg";
import { useUserSelect } from "@/User/Components/Select/use-user-select";
import classNameMerge from "classnames";
import { isNil, } from "lodash";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ReactSelect, { components } from "react-select";
import { twMerge } from "tailwind-merge";

const Select = ({
    id,
    name,
    isClearable = true,
    isSearchable = false,
    value,
    options,
    className,
    handleChange,
    placeholder = '',
    useDefaultEmpty = false,
    classNames = '',
    inputClasses = '',
    disabled = false,
    sort = false,
    isError = false,
}) => {
    const { optionArr, selectedValue } = useUserSelect({ sort, options, value });
    const DropdownIndicator = (props) => {
        const { menuIsOpen } = props.selectProps;

        return (
            <components.DropdownIndicator {...props}>
                <LazyLoadImage className={`w-3.5 h-3.5 transition-all duration-200 ${menuIsOpen && `-rotate-180`}`} src={ChevronDownIcon} />
            </components.DropdownIndicator>
        );
    };
    const Input = (props) => (
        <components.Input {...props} inputClassName={inputClasses} />
    );

    const Option = (props) => {
        const { children, innerProps, isSelected } = props;

        return (
            <div className="flex justify-between items-center p-2.5 hover:bg-silk-blue/[.08] cursor-pointer" {...innerProps}>
                <span className="text-sm leading-normal text-midnight">{children}</span>
                {isSelected && <img className="w-6 h-6" src={CheckDarkIcon} />}
            </div>
        );
    };

    const RM = ReactSelect?.default ? ReactSelect.default : ReactSelect;

    return (
        <RM
            menuPlacement="auto"
            id={id ? id : name}
            name={name}
            isDisabled={disabled}
            className={`react-select ${className}`}
            components={{
                DropdownIndicator,
                IndicatorSeparator: () => null,
                Input,
                Option,
            }}
            value={selectedValue}
            onChange={(e) => handleChange(e)}
            options={useDefaultEmpty ? [{ value: null, label: "" }, ...optionArr] : optionArr}
            isClearable={isClearable}
            isSearchable={isSearchable}
            pointerEvents={null}
            styles={{
                option: (baseStyles, { data }) => {
                    return isNil(data.value) || data.value === ''
                        ? { ...baseStyles, height: "2rem" }
                        : { ...baseStyles };
                },
            }}
            placeholder={placeholder}
            classNames={{
                ...classNames,
                control: (state) => classNameMerge(
                    `focus:!border-silk-blue hover:!border-silk-blue !rounded-lg !p-4 h-11.5 !shadow-none`,
                    {
                        'bg-white': !state.isDisabled,
                        'bg-platinum': state.isDisabled,
                        '!border-steel-grey': !isError,
                        '!border-free-speech-red': isError,
                    },
                    classNames?.control ? classNames.control() : '',
                ),
                valueContainer: () => `!p-0`,
                singleValue: () => twMerge(`!text-sm !leading-none font-light !text-midnight whitespace-nowrap overflow-auto ${inputClasses}`),
                placeholder: () => twMerge(`text-sm leading-none !text-steel-grey !m-0`),
                dropdownIndicator: () => `!p-0`,
                input: () => `text-sm leading-none h-3.5 !m-0 !p-0`,
                clearIndicator: () => `h-3.5 w-3.5 flex items-center justify-center`,
                menu: () => '!shadow-select-menu !rounded-lg !my-0.5',
                option: (state) => classNameMerge(
                    `!text-sm !leading-none !text-midnight !p-4`,
                    {
                        '!bg-silk-blue/[.08] ': state.isSelected,
                        '!bg-inherit': state.isFocused
                    },
                    classNames?.option ? classNames.option() : '',
                ),
            }}
        />
    );
};

export default Select;
